import { createSlice } from '@reduxjs/toolkit';

// Global UI state for lists/folders navigation tree expansion per network
// Shape: { [networkId: number]: { [folderId: number]: boolean } }
const initialState = {};

export const listsNavTreeUISlice = createSlice({
  name: 'listsNavTreeUI',
  initialState,
  reducers: {
    toggleFolderExpanded: (state, action) => {
      const { networkId, folderId } = action.payload;
      const current = state[networkId] || {};
      const next = { ...current, [folderId]: !current[folderId] };
      Object.assign(state, { [networkId]: next });
    },
    expandFolder: (state, action) => {
      const { networkId, folderId } = action.payload;
      const current = state[networkId] || {};
      if (current[folderId]) return;
      const next = { ...current, [folderId]: true };
      Object.assign(state, { [networkId]: next });
    },
    expandFolders: (state, action) => {
      const { networkId, folderIds } = action.payload; // folderIds: Iterable<number> | number[]
      const current = state[networkId] || {};
      const next = { ...current };
      folderIds.forEach((id) => {
        next[id] = true;
      });
      Object.assign(state, { [networkId]: next });
    },
    setExpandedForNetwork: (state, action) => {
      const { networkId, expandedMap } = action.payload; // expandedMap: { [id]: boolean }
      Object.assign(state, { [networkId]: { ...expandedMap } });
    },
  },
});

export const { toggleFolderExpanded, expandFolder, expandFolders, setExpandedForNetwork } = listsNavTreeUISlice.actions;

export default listsNavTreeUISlice.reducer;

export const expandedFoldersSelector = (state, networkId) => state.listsNavTreeUI?.[networkId] || {};
